<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>
            {{ (reference === 'new' ? 'Nuevo' : 'Editar') + ' atributo' }}
          </h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <!-- Reference -->
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Referencia"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  :disabled="reference !== 'new'"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-options"
                label="Opciones"
                label-for="options"
                class="col-12"
              >
                <multiselect
                  tagPlaceholder="Presiona enter para añadir la opción"
                  deselectLabel="Presiona enter para quitar la opción"
                  track-by="value"
                  :class="$v.form.options.$error ? 'is-invalid' : ''"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :preserve-search="true"
                  placeholder=""
                  label="text"
                  v-model="$v.form.options.$model"
                  :options="selectedAttributeOptions"
                  :taggable="true"
                  @tag="addTag"
                >
                  <template slot="noOptions">
                    {{
                      "$v.form.attribute.$model === 'TAMANO' || $v.form.attribute.$model === 'TAMANO_DIAM' || $v.form.attribute.$model === 'CAIDA'"
                        ? 'No hay opciones definidas. Puedes añadirlas escribiéndolas'
                        : 'No hay elementos'
                    }}</template
                  >
                </multiselect>

                <small
                  v-if="$v.form.options.$error"
                  id="input-options-feedback"
                  class="invalid-options text-danger"
                >
                  Este campo es obligatorio.
                </small>
              </b-form-group>
            </b-form-row>

            <b-button type="submit" variant="primary"
              >Guardar atributo</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';

import {
  required,
  minLength,
  decimal,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminGenericProductAttributesEditScreen',
  props: ['reference'],
  components: { Multiselect },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },

      options: {
        required,
        minLength: minLength(1),
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      reference: '',

      options: [],
      error: {
        show: false,
        text: '',
      },
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),

      selectedAttributeOptions: [],
      form: form,
    };
  },
  created() {
    if (this.reference !== 'new') {
      actions.getGenericProductAttribute(this.reference).then((x) => {
        this.form.reference = x.data.reference;

        this.form.options = x.data.options;
      });
    }
  },
  computed: {},
  methods: {
    addTag(newTag) {
      const tag = {
        value: newTag,
        text: newTag,
      };
      this.selectedAttributeOptions.push(tag);
      this.$v.form.options.$model.push(tag);
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {
        reference: this.form.reference,

        options: this.form.options,
      };

      if (this.reference !== 'new') {
        actions.patchGenericProductAttribute(this.reference, data).then((x) => {
          this.$router.push({ name: 'AdminGenericProductAttributesScreen' });
        });
      } else {
        actions.postGenericProductAttribute(data).then((x) => {
          this.$router.push({ name: 'AdminGenericProductAttributesScreen' });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
